import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        height: 48,
        justifyContent: 'center',
    },
    wrapperContent: {
        flexDirection: 'column',
        justifyContent: 'center',
    },
});

export default styles;
